/** The tenant used last on this device, so `/` can go straight there. A convenience only: any failure means "none". */
const KEY = 'fsv.lastTenant';

export function readLastTenant(): string | null {
  try {
    return window.localStorage.getItem(KEY);
  } catch {
    return null;
  }
}

export function writeLastTenant(slug: string): void {
  try {
    window.localStorage.setItem(KEY, slug);
  } catch {
    /* private mode: the picker asks again next time */
  }
}
